// Settings page (CHG-1239 / ITER-3362).
//
// Thin consumer per .forge/plans/v2-settings-shell.md §1.1.6. All data
// orchestration (query + mutation + dirty diff) lives in useSettings().
//
// Spec: specs/tier-05-experience/settings-v2.cross-screen.yaml.

import { SettingsPage } from "../components/composition";
import { SETTINGS_SECTIONS } from "../generated/settings-sections";
import { useSettings } from "../lib/useSettings";

export function Settings() {
  const { values, onChange, onSaveSection, dirty, busy, error } = useSettings();
  return (
    <SettingsPage
      sections={SETTINGS_SECTIONS}
      values={values}
      onChange={onChange}
      onSaveSection={onSaveSection}
      dirty={dirty}
      busy={busy}
      error={error}
    />
  );
}
